import React from "react";
import Header from "../layouts/Header/";
import Footer from "../layouts/Footer";
import SectionHeading from "../components/SectionHeading";

const MultiChainExplorer = () => {
  return (
    <>
      <Header />

 

      <section className="section-padding-100 service_single_content_area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              <div className="service_single_content text-center mb-10">
                <SectionHeading
                  title="Multi Chain Explorer"
                />
                <div className="service_cta mt-10">
                    <a href="https://crypto.databeast.ai/blockexplorer" className="btn dream-btn mt-1   0">
                      Try Multi Chain Explorer
                    </a>
                  </div>
                <div className="service_content_area text-left mt-50">
                  <p className="w-text" style={{ color: 'white' }}>
                    Our Multi Chain Explorer is a unified platform that provides comprehensive blockchain transaction 
                    information and account balance monitoring across multiple blockchain networks. No need to use 
                    different explorers - we've got all major chains covered in one interface.
                  </p>
                  
                  <div className="service_features mt-30">
                    <h4 className="w-text" style={{ color: 'white' }}>Supported Blockchain Networks:</h4>
                    <ul className="w-text" style={{ color: 'white' }}>
                      <li><i className="fa fa-check"></i> Ethereum</li>
                      <li><i className="fa fa-check"></i> Base</li>
                      <li><i className="fa fa-check"></i> Polygon</li>
                      <li><i className="fa fa-check"></i> Solana</li>
                      <li><i className="fa fa-check"></i> Arbitrum</li>
                      <li><i className="fa fa-check"></i> And many more...</li>
                    </ul>
                  </div>
                  
                  <div className="service_features mt-30">
                    <h4 className="w-text" style={{ color: 'white' }}>Key Features:</h4>
                    <ul className="w-text" style={{ color: 'white' }}>
                      <li><i className="fa fa-check"></i> Cross-chain transaction tracking</li>
                      <li><i className="fa fa-check"></i> Account balance monitoring across multiple networks</li>
                      <li><i className="fa fa-check"></i> Smart contract interaction history</li>
                      <li><i className="fa fa-check"></i> Gas fee analytics</li>
                      <li><i className="fa fa-check"></i> Token transfer tracking</li>
                      <li><i className="fa fa-check"></i> Address watchlist functionality</li>
                    </ul>
                  </div>
                  

                  

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default MultiChainExplorer;